export default "__VITE_ASSET__90ca98f4__"